import React from 'react';
import User from '../../types/User';

type UserContextProps = {
    user?: User;
    setUser?: Function;
};

export const UserContext = React.createContext<UserContextProps>({
    user: undefined,
    setUser: undefined,
});
